export default "__VITE_ASSET__DNSkYbDb__"